import { useState } from "react";
import { Camera, ChevronDown, Monitor } from "lucide-react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Button } from "@mui/material";

export const CameraSelector = ({
  devices,
  selectedDeviceId,
  onDeviceSelect,
  isLoading,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (deviceId) => {
    onDeviceSelect(deviceId);
    handleClose();
  };

  const selectedDevice = devices.find(
    (device) => device.deviceId === selectedDeviceId
  );

  return (
    <>
      <Button
        variant="outlined"
        className="glass-button rounded-xl p-3 hover:scale-105 transition-all duration-200"
        disabled={isLoading}
        onClick={handleClick}
        endIcon={<ChevronDown className="h-4 w-4" />}
        startIcon={<Camera className="h-5 w-5" />}
      >
        <span className="text-sm font-medium">
          {selectedDevice?.label || "Select Camera"}
        </span>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="glass-panel"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {devices.length === 0 ? (
          <MenuItem disabled className="text-muted-foreground">
            <Monitor className="h-4 w-4 mr-2" />
            No cameras detected
          </MenuItem>
        ) : (
          devices.map((device) => (
            <MenuItem
              key={device.deviceId}
              onClick={() => handleSelect(device.deviceId)}
              sx={{
                color:
                  device.deviceId === selectedDeviceId ? "#24B8E7" : "gray",
              }}
              className={`cursor-pointer transition-all duration-200`}
            >
              <Camera className="h-4 w-4 mr-2" />
              <span className="text-sm">{device.label}</span>
              {device.deviceId === selectedDeviceId && (
                <div className="h-2 w-2 bg-ar-success rounded-full ml-auto" />
              )}
            </MenuItem>
          ))
        )}
      </Menu>
    </>
  );
};
